export default {
    excess: 'Sorumluluk muafiyeti',
    security: 'Deposito',
    fuel_policy: 'Yakıt Politikası',
    like_for_like: 'Aldığın Gibi Bırak',
    full_to_full: 'Dolu Teslim Al, Dolu Teslim Et',
    mileage: 'Kilometre: kiralama başına {mileage} mil',
    unlimited_mileage: 'Sınırsız kilometre',
    non_refundable: 'İade Yok',
    free_cancellation_until: '{date} tarihine kadar ücretsiz iptal',
    cancellation_with_terms: '{0} iptal işlemleri ',
    t_c_text: 'Şart ve Koşullar doğrultusundadır',
    two_free_extras: 'Alım noktasında iki ücretsiz ekstra',
    glass_tyres_covered: 'Cam ve lastik güvenceli'
}
